import { Typography } from '@mui/material';

import IconButton from 'src/components/IconButton';
import type { Coin } from 'src/types/coin';

import CoinItem from './components/CoinItem';
import {
  Container,
  Divider,
  EmptyIconContainer,
  EmptyListContainer,
  Header,
  HeaderTitle,
  StyledBottomSheet,
  ValidatorContainer,
  ValidatorList,
} from './styled';

import { ReactComponent as CloseIcon } from 'src/assets/svg/Close.svg';
import { ReactComponent as EmptyValidatorsIcon } from 'src/assets/svg/TxTrackingFail.svg';

type CoinBottomSheetProps = Omit<React.ComponentProps<typeof StyledBottomSheet>, 'children'> & {
  coinList: Coin[];
  onClickCoin: (coinInfo: Coin) => void;
};

export default function CoinBottomSheet({ coinList, onClickCoin, onClose, ...remainder }: CoinBottomSheetProps) {
  return (
    <StyledBottomSheet
      {...remainder}
      onClose={() => {
        onClose?.({}, 'backdropClick');
      }}
    >
      <Container>
        <Header>
          <HeaderTitle>
            <Typography variant="h2">Select Coin</Typography>
          </HeaderTitle>
          <IconButton
            onClick={() => {
              onClose?.({}, 'backdropClick');
            }}
          >
            <CloseIcon />
          </IconButton>
        </Header>
        {coinList.length ? (
          <ValidatorContainer>
            <ValidatorList>
              {coinList.map((item) => (
                <CoinItem
                  key={item.denom}
                  coinInfo={item}
                  onClick={(coinInfo) => {
                    onClickCoin?.(coinInfo);
                  }}
                />
              ))}
            </ValidatorList>
            <Divider />
          </ValidatorContainer>
        ) : (
          <EmptyListContainer>
            <EmptyIconContainer>
              <EmptyValidatorsIcon />
            </EmptyIconContainer>
            <Typography variant="h4">No available Coins to select</Typography>
          </EmptyListContainer>
        )}
      </Container>
    </StyledBottomSheet>
  );
}
